<template>
  <div class="user" style="padding-top: 1rem;">
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Account'
      "
      font="#fff"
      color="#00c3f9"
      v-bind:isback="false"
    ></navTitle>
    <div class="headerbg bg-color-blue"></div>
    <div class="header acea-row row-between-wrapper">
      <div class="user-info">
        <div class="user-head">
          <div class="user-avatar">
            <img :src="userInfo.avatar" alt="" />
          </div>
          <div class="user-name">
            <div class="acea-row row-middle" style="margin-bottom: 0.2rem">
              <div class="name line1">{{ userInfo.nickname }}</div>
              <div class="member acea-row row-middle" v-if="userInfo.vip">
                <img class="vip-icon" :src="userInfo.vip_icon" />{{
                  userInfo.vip_name
                }}
              </div>
            </div>
            <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
              ID:{{ userInfo.uid || 0
              }}<span class="iconfont icon-bianji1"></span>
            </router-link>
            <router-link :to="'/user/binding'" class="bindingPhone" v-else>
              <span>Link phone number now</span>
            </router-link>
          </div>
        </div>
        <div class="user-currency">
          <div class="currency">
            <div class="integral">{{ userInfo.now_money }}</div>
            <div class="currency-name">Available balance({{icon_moeny}})</div>
          </div>
          <div class="currency">
            <div class="integral">{{ userInfo.integral }}</div>
            <div class="currency-name">My points</div>
          </div>
        </div>
      </div>

      <!--<div class="picTxt acea-row row-between-wrapper">-->
      <!--<div class="pictrue"><img :src="userInfo.avatar" /></div>-->
      <!--<div class="text">-->
      <!--<div class="acea-row row-middle">-->
      <!--<div class="name line1">{{ userInfo.nickname }}</div>-->
      <!--<div class="member acea-row row-middle" v-if="userInfo.vip">-->
      <!--<img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}-->
      <!--</div>-->
      <!--</div>-->
      <!--<router-link :to="'/user/data'" class="id" v-if="userInfo.phone">-->
      <!--ID:{{ userInfo.uid || 0-->
      <!--}}<span class="iconfont icon-bianji1"></span>-->
      <!--</router-link>-->
      <!--<router-link :to="'/user/binding'" class="binding" v-else>-->
      <!--<span>绑定手机号</span>-->
      <!--</router-link>-->
      <!--</div>-->
      <!--</div>-->
      <!--<span-->
      <!--class="iconfont icon-shezhi"-->
      <!--@click="$router.push({ path: '/user/data' })"-->
      <!--&gt;</span>-->
    </div>
    <div class="wrapper">
      <!--<div class="nav acea-row row-middle">-->
      <!--<router-link :to="{ path: '/user/account' }" class="item">-->
      <!--<div>我的余额</div>-->
      <!--<div class="num">{{ userInfo.now_money || 0 }}</div>-->
      <!--</router-link>-->
      <!--<router-link-->
      <!--:to="'/user/user_promotion'"-->
      <!--class="item"-->
      <!--v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"-->
      <!--&gt;-->
      <!--<div>当前佣金</div>-->
      <!--<div class="num">{{ userInfo.brokerage_price || 0 }}</div>-->
      <!--</router-link>-->
      <!--<router-link :to="'/user/integral'" class="item" v-else>-->
      <!--<div>当前积分</div>-->
      <!--<div class="num">{{ userInfo.integral || 0 }}</div>-->
      <!--</router-link>-->
      <!--<router-link :to="'/user/user_coupon'" class="item">-->
      <!--<div>优惠券</div>-->
      <!--<div class="num">{{ userInfo.couponCount || 0 }}</div>-->
      <!--</router-link>-->
      <!--</div>-->
      <!--<div class="myOrder">-->
      <!--<div class="title acea-row row-between-wrapper">-->
      <!--<div>我的订单</div>-->
      <!--<router-link :to="'/order/list/'" class="allOrder">-->
      <!--全部订单-->
      <!--&lt;!&ndash; <span class="iconfont icon-jiantou"></span> &ndash;&gt;-->
      <!--</router-link>-->
      <!--</div>-->
      <!--<div class="orderState acea-row row-middle">-->
      <!--&lt;!&ndash; <router-link :to="{ path: '/order/list/' + 0 }" class="item">-->
      <!--<div class="pictrue">-->
      <!--<img src="@assets/images/dfk.png" />-->
      <!--<span-->
      <!--class="order-status-num"-->
      <!--v-if="orderStatusNum.unpaid_count > 0"-->
      <!--&gt;{{ orderStatusNum.unpaid_count }}</span-->
      <!--&gt;-->
      <!--</div>-->
      <!--<div>待付款</div>-->
      <!--</router-link> &ndash;&gt;-->
      <!--<router-link :to="{ path: '/order/list/' + 1 }" class="item">-->
      <!--<div class="pictrue">-->
      <!--<img src="@assets/images/dcz.png" style="width: 0.43rem;height: 0.544rem;" />-->
      <!--<span-->
      <!--class="order-status-num"-->
      <!--v-if="orderStatusNum.unshipped_count > 0"-->
      <!--&gt;{{ orderStatusNum.unshipped_count }}</span-->
      <!--&gt;-->
      <!--</div>-->
      <!--<div>待操作</div>-->
      <!--</router-link>-->
      <!--<router-link :to="{ path: '/order/list/' + 2 }" class="item">-->
      <!--<div class="pictrue">-->
      <!--<img src="@assets/images/daifahuo.png"  style="width: 0.43rem;height: 0.544rem;" />-->
      <!--<span-->
      <!--class="order-status-num"-->
      <!--v-if="orderStatusNum.received_count > 0"-->
      <!--&gt;{{ orderStatusNum.received_count }}</span-->
      <!--&gt;-->
      <!--</div>-->
      <!--<div>待收货</div>-->
      <!--</router-link>-->
      <!--<router-link :to="{ path: '/order/list/' + 4 }" class="item">-->
      <!--<div class="pictrue">-->
      <!--<img src="@assets/images/daishouhuo.png" style="width: 0.56 rem;height: 0.54rem;"/>-->
      <!--<span-->
      <!--class="order-status-num"-->
      <!--v-if="orderStatusNum.evaluated_count > 0"-->
      <!--&gt;{{ orderStatusNum.evaluated_count }}</span-->
      <!--&gt;-->
      <!--</div>-->
      <!--<div>已完成</div>-->
      <!--</router-link>-->
      <!--<router-link :to="'/order/refund_list'" class="item">-->
      <!--<div class="pictrue">-->
      <!--<img src="@assets/images/th.png" style="width: 0.54rem;height: 0.54rem;" />-->
      <!--<span-->
      <!--class="order-status-num"-->
      <!--v-if="orderStatusNum.refund_count > 0"-->
      <!--&gt;{{ orderStatusNum.refund_count }}</span-->
      <!--&gt;-->
      <!--</div>-->
      <!--<div>售后/退款</div>-->
      <!--</router-link>-->
      <!--</div>-->
      <!--</div>-->
      <div class="function">
        <!-- 充值按钮 -->
        <!-- <div class="item bg-color-blue" style="width:100%" @click="rechargMoney">
          <div><img src="../../assets/images/funA.png" alt="" /></div>
          <div>Top-up</div>
        </div> -->
        <!-- 提现按钮 -->
        <!-- <div class="item  bg-color-yellow" @click="withdrawMoney">
          <div><img src="../../assets/images/funB.png" alt="" /></div>
          <div>Cash withdrawal</div>
        </div> -->
      </div>
      <!-- 功能列表 -->
      <!--<div class="myService">-->
      <!--&lt;!&ndash; <div class="title acea-row row-middle">我的服务</div> &ndash;&gt;-->
      <!--<div class="serviceList acea-row row-middle">-->
      <!--<template v-for="(item, index) in FUN">-->
      <!--<div-->
      <!--class="item"-->
      <!--:key="index"-->
      <!--@click="goPagesLocal(index)"-->
      <!--v-if="item.wap_url"-->
      <!--&gt;-->
      <!--<div class="pictrue">-->
      <!--<img :src="item.pic" />-->
      <!--</div>-->
      <!--<div>{{ item.name }}</div>-->
      <!--</div>-->
      <!--</template>-->
      <!--&lt;!&ndash;<div&ndash;&gt;-->
      <!--&lt;!&ndash;class="item"&ndash;&gt;-->
      <!--&lt;!&ndash;@click="changeswitch(true)"&ndash;&gt;-->
      <!--&lt;!&ndash;v-if="userInfo.phone && isWeixin"&ndash;&gt;-->
      <!--&lt;!&ndash;&gt;&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="pictrue"><img src="@assets/images/switch.png" /></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div>账号切换</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--</div>-->
      <!--</div>-->

      <div
        class="myService"
        v-if="MyMenus.length"
        style="margin-bottom: 0.4rem"
      >
        <!--<div class="title acea-row row-middle">我的服务</div>-->
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div style="width: 100%;height: 1.5rem"></div>
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
  </div>
</template>
<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import navTitle from "@components/navTitle";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    navTitle
  },
  props: {},
  data: function() {
    return {
      icon_moeny:this.global.moeny,
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false
      // FUN:[
      //   {
      //     id: 135,
      //     name: "我要推广",
      //     pic: "http://qny.tuchuang.mqllin.cn/FuT2KUddtShOUGAcLlOfpsS4S0Gj",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/user/user_promotion",
      //   },
      //   {
      //     id: 135,
      //     name: "商城公告",
      //     pic: "http://qny.tuchuang.mqllin.cn/Fol_Tij42xrsqpYSsY1jZbNYPfQ8",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/news_list",
      //   },
      //
      //   {
      //     id: 135,
      //     name: "用户须知",
      //     pic: "http://qny.tuchuang.mqllin.cn/FiLYu5ARD5wV-_WDuaO3Qv5wnscz",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/user/usermessages",
      //   },
      //   {
      //     id: 135,
      //     name: "实名认证",
      //     pic: "http://qny.tuchuang.mqllin.cn/FgwOztBt7MGSQpQJ33Qv1MPLd4P_",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/user/vip",
      //   },
      //
      //   {
      //     id: 135,
      //     name: "余额明细",
      //     pic: "http://qny.tuchuang.mqllin.cn/FqTpoZGhyzHHCz5WM4Krz_qO0bbq",
      //     url: "/pages/user_vip/index",
      //     wap_url: "user/bill/0",
      //   },
      //   {
      //     id: 135,
      //     name: "积分明细",
      //     pic: "http://qny.tuchuang.mqllin.cn/FmvBeS-4mhZz7GlnqkBp_SZgKnJ2",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/user/integral",
      //   },
      //   {
      //     id: 135,
      //     name: "我的地址",
      //     pic: "http://qny.tuchuang.mqllin.cn/FpzzMuyjASiuhn3TIgAfPABFNnHu",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/user/add_manage",
      //   },
      //   {
      //     id: 135,
      //     name: "榜单",
      //     pic: "http://qny.tuchuang.mqllin.cn/FpQ-3t4mdheZ8xrkxWFvDvseVsOg",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/user/rank",
      //   },
      //   {
      //     id: 135,
      //     name: "我的客服",
      //     pic: "http://qny.tuchuang.mqllin.cn/FqkJhHxmkbTGg3XjhHevo4v0fqvJ",
      //     url: "/pages/user_vip/index",
      //     wap_url: "/customer/list",
      //   },
      //   // {
      //   //   id: 135,
      //   //   name: "设置",
      //   //   pic: "http://datong.crmeb.net/public/uploads/attach/2019/03/28/5c9ccc9934a7c.png",
      //   //   url: "/pages/user_vip/index",
      //   //   wap_url: "/user/vip",
      //   // },
      //
      // ]
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.User();
        this.MenuUser();
      }
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    // this.isWeixin = isWeixin();
  },
  methods: {
    rechargMoney: function() {
      this.$router.push({ path: "/user/Recharge_cash" });
    },
    withdrawMoney: function() {
      this.$router.push({ path: "/user/user_cash_public" });
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        that.localStorage.set('is_promoter',res.data.is_promoter)

      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      let title = this.MyMenus[index].name;
      // if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
      //   if (!this.userInfo.is_promoter)
      //     return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      // }
      // if (url === "/customer/index" && !this.userInfo.adminid) {
      //   return this.$dialog.toast({ mes: "您还不是客服！！" });
      // }

      this.$router.push({
        path: this.MyMenus[index].wap_url,
        query: { ti: title }
      });
    },
    goPagesLocal: function(index) {
      let url = this.FUN[index].wap_url;
      if (url === "/user/user_promotion" && this.userInfo.statu === 1) {
        if (!this.userInfo.is_promoter)
          return this.$dialog.toast({ mes: "Unauthorised to promote！" });
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "You are not a customer service！" });
      }

      this.$router.push({ path: this.FUN[index].wap_url });
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
.function {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 0.15rem;
}
.function .item {
  width: 49%;
  height: 2.448rem;
  padding: 0.75rem 0;
  box-sizing: border-box;
  color: #fff;
  text-align: center;
  border-radius: 0.15rem;
}
.function .item img {
  width: 0.45rem;
  margin-bottom: 0.2rem;
}
.function .bg-color-blue {
  background: #00c3f9;
}
.function .bg-color-yellow {
  background: #fcbb01;
}
.user-info {
  width: 100%;
  height: 3.53rem;
  background: #fff;
  border-radius: 0.15rem;
  /*background: url("../../assets/images/userBack.png") no-repeat;*/
  /*background-size: 100% 100%;*/
  padding: 0.47rem 0.63rem 0rem 0.63rem;
  box-sizing: border-box;
}

.user-head {
  width: 100%;
  display: flex;
  margin-bottom: 0.5rem;
}
.user-avatar {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  overflow: hidden;
}
.user-avatar img {
  width: 100%;
  height: 100%;
}
.vip-icon {
  width: 0.28rem;
  height: 0.28rem;
  font-size: 0.2rem;
  margin-right: 0.08rem;
}
.user-name {
  width: 4.34rem;
  color: rgba(255, 255, 255, 1);
  margin-left: 0.35rem;
  text-align: left;
  color: #333333;

  /*display: flex;*/
}
.user-name a {
  display: block;
}
.user-name .name {
  font-size: 0.32rem;
  max-width: 2.6rem;
  width: unset;
}
.user-name .member {
  padding: 0 0.1rem;
  height: 0.36rem;
  background-color: rgba(0, 0, 0, 0.2);
  font-size: 0.2rem;
  border-radius: 0.3rem;
  margin-left: 0.17rem;
  color: #444444;
}
.user-currency {
  width: 100%;
  /*height: 2rem;*/
  display: flex;
}
.user-currency .currency {
  flex: 1;
  position: relative;
  text-align: center;
}
.user-currency .currency .integral {
  font-size: 0.455rem;
  color: #333;
}

.user-currency .currency .currency-name {
  font-size: 0.25rem;
  color: #999;
}

.user-currency .currency:first-child::after {
  width: 1px;
  height: 50%;
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  background: #ccc;
}
.bindingPhone {
  width: 100%;
  color: #999;
  text-align: center;
  border-radius: 0.05rem;
  background: #f6f7f8;
  padding: 0.05rem;
  /*text-decoration: underline;*/
}
.headerbg {
  width: 100%;
  height: 1.5rem;
  position: absolute;
  top: 1rem;
  z-index: -1;
}
.headerbg:after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.98rem;
  z-index: -1;
  content: "";
  height: 1rem;
  width: 100%;
  border-radius: 0 0 10% 10%;
  background-color: #00c3f9;
}
</style>
